const radius = {
  small: '0.1875rem',
  medium: '0.5rem',
  large: '0.75rem',
} as const;

export default radius;
